import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "@/i18n";

/**
 * Injects/updates <link rel="alternate" hreflang="..."> tags + canonical
 * in <head> based on current path and supported languages.
 */
export default function HreflangTags() {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const origin = window.location.origin;
    const path = pathname || "/";

    // Cleanup previous
    document
      .querySelectorAll('link[data-corporaco-hreflang="true"], link[data-corporaco-canonical="true"]')
      .forEach((el) => el.remove());

    // hreflang alternates
    SUPPORTED_LANGUAGES.forEach((l) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = l.code;
      link.href = `${origin}${path}${path.includes("?") ? "&" : "?"}lang=${l.code}`;
      link.setAttribute("data-corporaco-hreflang", "true");
      document.head.appendChild(link);
    });
    // x-default
    const xd = document.createElement("link");
    xd.rel = "alternate";
    xd.hreflang = "x-default";
    xd.href = `${origin}${path}`;
    xd.setAttribute("data-corporaco-hreflang", "true");
    document.head.appendChild(xd);

    // canonical
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = `${origin}${path}`;
    canonical.setAttribute("data-corporaco-canonical", "true");
    document.head.appendChild(canonical);

    // sitemap discovery (for crawlers that read HTML head)
    if (!document.querySelector('link[rel="sitemap"]')) {
      const sm = document.createElement("link");
      sm.rel = "sitemap";
      sm.type = "application/xml";
      sm.href = `${origin}/api/sitemap.xml`;
      document.head.appendChild(sm);
    }
  }, [pathname, i18n.language]);

  return null;
}
